import merge from "lodash/merge";


class Confsite {
    constructor() {
        this.id = 0;
        this.name = "";
        this.type = "";
        this.traffic = "";
        this.introduction = "";
        this.tranship = "";
        this.conference_id = 0;
        this.create_time = new Date();
        this.flag = "";
        this.isrequired = false;
    }
    static async getList(filters) {

        const url = process.env.VUE_APP_API_URL + 'api/v1/confsite'
        if (!filters.per_page || filters.per_page == '') {
          filters.per_page = -1
        }
        return await axios.get(url, { params: filters }).then((res) => {
          let returndata = {}
          returndata.result = []
          let c = new Confsite()
          res.data.results.forEach((x) => {
            let c = new Confsite()
            Object.assign(c, x)
            returndata.result.push(c)
          })
          // 默认按order排序
          returndata.result = returndata.result.sort((a, b) =>
            a.order < b.order ? -1 : 1
          )
          returndata.total = res.data.total
          return returndata
        })
      } 



       createOrUpdate() {
          const url =
            process.env.VUE_APP_API_URL + "api/v1/confsite" 
            if (this.id==0) {
                //新增
              const data = merge({}, this);

              return axios.post(url, data).then((res) => {
                let result = new Confsite();
                result = merge(result, res);
                return result;
              });
            }else{
              //修改
                const data = merge({}, this);

                return axios
                  .put(url, data)
                  .then((res) => {
                    let result = new Confsite();
                    result = merge(result, res.data.item);
                    return result;
                  });
            }
        }
        static isfulled(signup_id) {
          const url =
            process.env.VUE_APP_API_URL + "api/v1/confsite/fulled" 
                //新增
            const data = {signup_id};

            return axios.post(url, data).then((res) => {
              return res;
            });
        }
        static delete(id){
            const url = process.env.VUE_APP_API_URL + "api/v1/confsite"
            return axios.delete(url, {params: {id:id}}).then(res=>{
              return true
            })
          }
      

}
export { Confsite};